module.exports = __webpack_public_path__ + "img/code-reviewer.6135ef37.webp";